
import React from 'react';

interface MessageBubbleProps {
  content: string;
  isUser: boolean;
  isPlaying: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ content, isUser, isPlaying }) => {
  
  // Simple "Markdown-lite" parser for bold text (**text**) and code blocks (```text```)
  const renderContent = (text: string) => {
    const parts = text.split(/(```[\s\S]*?```|\*\*.+?\*\*)/g);
    
    return parts.map((part, index) => {
        if (part.startsWith('```') && part.endsWith('```')) {
            const code = part.slice(3, -3).trim();
            return (
                <div key={index} className="my-2 p-3 bg-black/80 text-emerald-400 font-mono text-[10px] rounded-lg border border-white/10 overflow-x-auto whitespace-pre-wrap dir-ltr text-left">
                    {code}
                </div>
            );
        }
        if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={index} className="font-black text-emerald-500 dark:text-emerald-400">{part.slice(2, -2)}</strong>;
        }
        return <span key={index}>{part}</span>;
    });
  };

  return (
    <div className={`
      relative px-5 py-4 rounded-[26px] text-[13px] lg:text-[14px] font-medium leading-7 transition-all duration-300
      ${isUser 
        ? 'bg-gradient-to-br from-emerald-500 to-emerald-600 text-white rounded-tr-none shadow-lg shadow-emerald-500/20' 
        : 'bg-white dark:bg-[#1a1a20] text-slate-700 dark:text-slate-200 rounded-tl-none border border-slate-100 dark:border-white/5 shadow-sm'}
      ${isPlaying ? 'ring-2 ring-emerald-500/50' : ''}
    `}>
      <div className="break-words">
        {renderContent(content)}
      </div>
      
      {!isUser && isPlaying && (
        <div className="absolute -left-2 bottom-0 flex gap-0.5 items-end p-2 bg-emerald-500/10 rounded-xl backdrop-blur-md border border-emerald-500/20">
           <div className="w-1 h-3 bg-emerald-500 animate-[wave_1s_infinite]"></div>
           <div className="w-1 h-5 bg-emerald-500 animate-[wave_1.2s_infinite_0.1s]"></div>
           <div className="w-1 h-3 bg-emerald-500 animate-[wave_0.8s_infinite_0.2s]"></div>
        </div>
      )}
    </div>
  );
};

export default MessageBubble;
